export {default as ClickableDiv} from './clickable-div';
